// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "ai.spotonchain.platform",
    name: "Spot On Chain App",
    homepage: "https://platform.spotonchain.ai",
    image_id: "1bcb5ed6-f6c9-4b0d-f891-b70c48b93d00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/spot-on-chain/id6449733489",
        android: "https://play.google.com/store/apps/details?id=network.spotonchain",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "spotonchain://",
        universal: "https://spotonchain.ai/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map